import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router';

import { useLogout } from '@jane/business-admin/data-access';
import { useStoreDetails } from '@jane/business-admin/providers/StoreDetailsProvider';
import { EventNames, normalizePath, track } from '@jane/business-admin/util';

export const useLogoutAndNavigateToLogin = () => {
  const { pathname } = useLocation();
  const { storeId } = useStoreDetails();
  const { mutate: logout, isSuccess: logoutSuccess } = useLogout();

  useEffect(() => {
    if (logoutSuccess) {
      track({
        event: EventNames.LoggedOut,
        // TODO: storeId is always an empty string here
        from_url: normalizePath(pathname, storeId),
      });
    }
  }, [logoutSuccess, storeId]);

  // Memoize so consumers can safely include this in useEffect dependencies
  // without triggering the effect on every render. Without this, callers like
  // RequireAnonymousUser fire logout() in an infinite loop because the
  // returned closure is a new reference on each render.
  return useCallback(() => {
    logout();
  }, [logout]);
};
